import React from 'react'; //eslint-disable-line
import Slider from "react-slick";
import './instagramSlider.less';

export default function({ sliderSettings, instagramPosts }) {
	return (
		<Slider {...sliderSettings} className="insta-slider">
			{
				instagramPosts.map(item => (
					<img key={item.id} src={item.image_url} width={150} height={150} alt="instaPhoto" />
				))
			}
		</Slider>
	);
}



// WEBPACK FOOTER //
// ./src/components/Modules/InstagramSlider/index.js